/* RAFFIN ART — Página de producto "ra-" */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var R = window.RAFFIN || {};
  var root = (R.routes && R.routes.root) || '/';

  function money(cents) {
    var f = R.moneyFormat || '${{amount_no_decimals}}';
    var m = f.match(/\{\{\s*(\w+)\s*\}\}/), k = m ? m[1] : 'amount';
    var dec = /no_decimals/.test(k) ? 0 : 2;
    var th = /comma_separator/.test(k) ? '.' : (/space/.test(k) ? ' ' : (/apostrophe/.test(k) ? "'" : ','));
    var ds = /comma_separator/.test(k) ? ',' : '.';
    var p = (cents / 100).toFixed(dec).split('.');
    var out = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (p[1] ? ds + p[1] : '');
    return f.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  /* ---------- Galería ---------- */
  function initGallery(sec) {
    var g = $('[data-ra-gal]', sec);
    if (!g || g._ra) return; g._ra = true;
    var track = $('[data-ra-track]', g);
    var slides = $$('[data-ra-slide]', g);
    var thumbs = $$('[data-ra-thumb]', sec);
    var dots = $$('[data-ra-dots] span', g);
    var count = $('[data-ra-count]', g);
    var idx = 0;
    function paint(i) {
      idx = i;
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      var at = thumbs[i];
      if (at && at.parentElement) {
        var p = at.parentElement;
        p.scrollTo({ left: at.offsetLeft - p.clientWidth / 2 + at.clientWidth / 2, behavior: 'smooth' });
      }
    }
    function go(i) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      paint(i);
    }
    g._go = go;
    g._goMedia = function (id) {
      var i = slides.findIndex(function (s) { return s.dataset.mediaId == id; });
      if (i > -1) go(i);
    };
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
    var prev = $('[data-ra-prev]', g), next = $('[data-ra-next]', g);
    prev && prev.addEventListener('click', function () { go(idx - 1); });
    next && next.addEventListener('click', function () { go(idx + 1); });
    var st;
    track.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== idx) paint(i);
      }, 70);
    }, { passive: true });
    var start = slides.findIndex(function (s) { return s.classList.contains('is-start'); });
    if (start > 0) { track.scrollLeft = slides[start].offsetLeft; paint(start); } else paint(0);
    var auto = +g.dataset.autoplay || 0, timer;
    function play() { clearInterval(timer); if (auto > 0 && !(window.Shopify && Shopify.designMode)) timer = setInterval(function () { go(idx + 1); }, auto * 1000); }
    g.addEventListener('pointerenter', function () { clearInterval(timer); });
    g.addEventListener('pointerleave', play);
    track.addEventListener('touchstart', function () { clearInterval(timer); }, { passive: true });
    play();
    if (window.matchMedia('(hover: hover)').matches) {
      track.addEventListener('click', function (e) {
        var img = e.target.closest('img');
        if (img) openLb(img.currentSrc || img.src);
      });
    }
  }

  /* ---------- Lightbox ---------- */
  var lb;
  function openLb(src) {
    if (!lb) {
      lb = document.createElement('div');
      lb.className = 'ra-sec ra-lb';
      lb.style.padding = '20px';
      lb.innerHTML = '<img alt="">';
      lb.addEventListener('click', function () { lb.classList.remove('is-open'); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') lb.classList.remove('is-open'); });
      document.body.appendChild(lb);
    }
    lb.querySelector('img').src = src;
    lb.classList.add('is-open');
  }

  /* ---------- Variantes, cantidad y compra ---------- */
  function initBuy(sec) {
    var jsonEl = $('[data-ra-variants]', sec);
    if (!jsonEl || sec._raBuy) return; sec._raBuy = true;
    var variants = JSON.parse(jsonEl.textContent || '[]');
    var form = $('[data-ra-form]', sec);
    var idInput = form && $('input[name="id"]', form);
    var gal = $('[data-ra-gal]', sec);

    function current() {
      var groups = $$('[data-ra-opt]', sec);
      if (!groups.length) return null;
      var sel = groups.map(function (g) { var c = $('input:checked', g); return c ? c.value : null; });
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); });
    }
    function update(v) {
      var btns = $$('[data-ra-add], [data-ra-buynow], [data-ra-sticky-btn]', sec);
      if (!v) { btns.forEach(function (b) { b.disabled = true; }); return; }
      if (idInput) idInput.value = v.id;
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch (e) {}
      $$('[data-ra-price]', sec).forEach(function (el) { el.textContent = money(v.price); });
      var onSale = v.compare > v.price;
      $$('[data-ra-compare]', sec).forEach(function (el) { el.hidden = !onSale; el.textContent = onSale ? money(v.compare) : ''; });
      $$('[data-ra-off]', sec).forEach(function (el) { el.hidden = !onSale; el.textContent = onSale ? '-' + Math.round((v.compare - v.price) * 100 / v.compare) + '%' : ''; });
      $$('[data-ra-save]', sec).forEach(function (el) {
        el.hidden = !onSale;
        if (onSale) el.innerHTML = (el.dataset.label || 'Ahorras') + ' <b>' + money(v.compare - v.price) + '</b>';
      });
      btns.forEach(function (b) {
        b.disabled = !v.available;
        var l = $('[data-ra-label]', b);
        if (l) l.textContent = v.available ? (l.dataset.on || l.textContent) : 'Agotado';
      });
      $$('[data-ra-optlabel]', sec).forEach(function (el, i) { el.textContent = v.options[+el.dataset.raOptlabel] || ''; });
      if (v.media && gal && gal._goMedia) gal._goMedia(v.media);
      syncApps(v);
    }
    /* apps (Releasit, etc.) que traen su propio formulario: les pasamos la variante elegida */
    function syncApps(v) {
      if (!v) return;
      $$('.shopify-app-block form[action*="/cart/add"] [name="id"]', sec).forEach(function (i) {
        if (String(i.value) === String(v.id)) return;
        i.value = v.id;
        i.dispatchEvent(new Event('input', { bubbles: true }));
        i.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    $$('[data-ra-opt] input', sec).forEach(function (r) { r.addEventListener('change', function () { update(current()); }); });
    syncApps(current());
    setTimeout(function () { syncApps(current()); }, 1500);

    /* cantidad */
    $$('[data-ra-qty]', sec).forEach(function (q) {
      var input = $('input', q);
      $$('button', q).forEach(function (b) {
        b.addEventListener('click', function () { input.value = Math.max(1, (+input.value || 1) + (+b.dataset.step)); });
      });
    });

    /* comprar ahora: agrega y va al checkout */
    $$('[data-ra-buynow]', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        if (!form) return;
        b.classList.add('is-loading');
        var fd = new FormData(form);
        fetch(root.replace(/\/$/, '') + '/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
          .then(function (r) { return r.json(); })
          .then(function (d) { if (d.status) throw new Error(d.description || 'Error'); location.href = root.replace(/\/$/, '') + '/checkout'; })
          .catch(function (err) { b.classList.remove('is-loading'); alert(err.message || 'No pudimos procesar tu compra'); });
      });
    });

    /* barra fija */
    var sticky = $('[data-ra-sticky]', sec);
    var app = $('.ra-info .shopify-app-block', sec);
    var zone = $('[data-ra-buyzone]', sec);
    var anchor = app || (zone && zone.offsetParent !== null ? zone : null) || form;
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
      }).observe(anchor);
      var sb = $('[data-ra-sticky-btn]', sticky);
      sb && sb.addEventListener('click', function () {
        var mode = sb.dataset.mode;
        if (app) {
          var cod = $('button, a, [role=button]', app);
          if (cod) { cod.click(); return; }
          app.scrollIntoView({ behavior: 'smooth', block: 'center' }); return;
        }
        if (mode === 'scroll') { anchor.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        var target = mode === 'checkout' ? $('[data-ra-buynow]', sec) : $('[data-ra-add]', sec);
        if (target) target.click(); else anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  /* ---------- Entrega estimada ---------- */
  function addBiz(d, n) { d = new Date(d); var a = 0; while (a < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) a++; } return d; }
  function initDelivery(sec) {
    $$('[data-ra-delivery]', sec).forEach(function (el) {
      var min = +el.dataset.min || 2, max = +el.dataset.max || 5;
      var f = new Intl.DateTimeFormat('es-CO', { weekday: 'long', day: 'numeric', month: 'long' });
      var a = $('[data-from]', el), b = $('[data-to]', el);
      a && (a.textContent = f.format(addBiz(new Date(), min)));
      b && (b.textContent = f.format(addBiz(new Date(), max)));
    });
  }

  /* ---------- Antes / después ---------- */
  function initBA(sec) {
    $$('[data-ra-ba]', sec).forEach(function (ba) {
      var r = $('input[type=range]', ba);
      if (!r || r._ra) return; r._ra = true;
      var set = function () { ba.style.setProperty('--pos', r.value + '%'); };
      r.addEventListener('input', set); set();
    });
  }

  /* ---------- Reseñas ---------- */
  function initReviews(sec) {
    var box = $('[data-ra-reviews]', sec);
    if (!box || box._ra) return; box._ra = true;
    var cards = $$('[data-ra-rv]', box);
    var per = window.innerWidth < 750 ? (+box.dataset.perMobile || 4) : (+box.dataset.per || 6);
    var shown = per, filter = 'all';
    var more = $('[data-ra-more]', box);
    function match(c) {
      if (filter === 'all') return true;
      if (filter === 'photo') return c.dataset.photo === '1';
      return c.dataset.stars === filter;
    }
    function render() {
      var list = cards.filter(match);
      cards.forEach(function (c) { c.hidden = true; });
      list.slice(0, shown).forEach(function (c) { c.hidden = false; });
      if (more) more.hidden = list.length <= shown;
      var em = $('[data-ra-empty]', box); if (em) em.hidden = list.length > 0;
    }
    $$('[data-ra-filter]', box).forEach(function (b) {
      b.addEventListener('click', function () {
        filter = b.dataset.raFilter; shown = per;
        $$('[data-ra-filter]', box).forEach(function (x) { x.classList.toggle('is-active', x === b); });
        render();
      });
    });
    more && more.addEventListener('click', function () { shown += per; render(); });
    $$('[data-ra-zoom]', box).forEach(function (z) { z.addEventListener('click', function () { openLb(z.dataset.raZoom); }); });
    render();
  }

  function initAll(ctx) {
    $$('.ra-sec', ctx).forEach(function (sec) {
      initGallery(sec); initBuy(sec); initDelivery(sec); initBA(sec); initReviews(sec);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var s = e.target.closest('[data-ra-slide]');
    if (s) { var g = s.closest('[data-ra-gal]'); var i = $$('[data-ra-slide]', g).indexOf(s); g && g._go && g._go(i); }
  });
})();
